import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';
//import { AbpHttpConfiguration } from 'abp-ng2-module/dist/src/abpHttpInterceptor';
import { TokenService } from 'abp-ng2-module/dist/src/auth/token.service';
import { UtilsService } from 'abp-ng2-module/dist/src/utils/utils.service';
import { LogService } from 'abp-ng2-module/dist/src/log/log.service';
import { Observable, Subject } from 'rxjs';
import { AbpHttpConfiguration } from './abp-http-configuration';
import { SpinnerService } from '../../app/views/pages/transpop/shared/spinner.service';
import { __await } from 'tslib';
import { UIMessage } from '../../shared/helpers/UIMessage';
//import { AbpHttpConfiguration } from 'abp-ng2-module/dist/src/abpHttpInterceptor';
//import { AbpHttpConfiguration } from './abp-http-configuration';

@Injectable({
    providedIn: 'root'
})
export class CustomHttpInterceptor  implements HttpInterceptor {


    protected configuration: AbpHttpConfiguration;
    private _tokenService: TokenService = new TokenService();
    private _utilsService: UtilsService = new UtilsService();
    private _logService: LogService = new LogService();
    private _uiMessage: UIMessage = new UIMessage();

	constructor(configuration: AbpHttpConfiguration,
    private spinnerService: SpinnerService) {
        this.configuration = configuration;
    }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

	   this.spinnerService.isLoading.next(1);

      var interceptObservable = new Subject<HttpEvent<any>>();
	  var modifiedRequest = this.normalizeRequestHeaders(request);


		next.handle(modifiedRequest)
			.subscribe((event: HttpEvent<any>) => {

        // this.spinnerService.isLoading.next(1);

				this.handleSuccessResponse(event, interceptObservable);
			

			}, (error: any) => {

				//Birden fazla method aynı anda çalışır ve biri patlarsa
				//elle manuel olarak eklediğimiz bu spinner kapansın diye ekledim.
				//combineLatest kullanılan yerler için ekledim.
				this.spinnerService.isLoadingByOrderPageStep3.next(false);

				return this.handleErrorResponse(error, interceptObservable);


			});
  
      return interceptObservable;
    }


    protected normalizeRequestHeaders(request: HttpRequest<any>):HttpRequest<any> {
      var modifiedHeaders = new HttpHeaders();
      modifiedHeaders = request.headers.set("Pragma","no-cache")
                                          .set("Cache-Control","no-cache")
                                          .set("Expires", "Sat, 01 Jan 2000 00:00:00 GMT");
      
      modifiedHeaders = this.addXRequestedWithHeader(modifiedHeaders);
      modifiedHeaders = this.addAuthorizationHeaders(modifiedHeaders);
      modifiedHeaders = this.addAspNetCoreCultureHeader(modifiedHeaders);
      modifiedHeaders = this.addAcceptLanguageHeader(modifiedHeaders);
      modifiedHeaders = this.addTenantIdHeader(modifiedHeaders);

      return request.clone({
          headers: modifiedHeaders
      });
	}


   
  protected addXRequestedWithHeader(headers:HttpHeaders):HttpHeaders {
    if (headers) {
        headers = headers.set('X-Requested-With', 'XMLHttpRequest');
    }

    return headers;
}

protected addAspNetCoreCultureHeader(headers:HttpHeaders):HttpHeaders {
  let cookieLangValue = this._utilsService.getCookieValue("Abp.Localization.CultureName");
  if (cookieLangValue && headers && !headers.has('.AspNetCore.Culture')) {
      headers = headers.set('.AspNetCore.Culture', cookieLangValue);
  }

  return headers;
}

protected addAcceptLanguageHeader(headers:HttpHeaders):HttpHeaders {
  let cookieLangValue = this._utilsService.getCookieValue("Abp.Localization.CultureName");
  if (cookieLangValue && headers && !headers.has('Accept-Language')) {
      headers = headers.set('Accept-Language', cookieLangValue);
  }

  return headers;
}

protected addTenantIdHeader(headers:HttpHeaders):HttpHeaders {
  let cookieTenantIdValue = this._utilsService.getCookieValue('Abp.TenantId');
  if (cookieTenantIdValue && headers && !headers.has('Abp.TenantId')) {
      headers = headers.set('Abp.TenantId', cookieTenantIdValue);
  }

  return headers;
}

protected addAuthorizationHeaders(headers:HttpHeaders): HttpHeaders {
  let authorizationHeaders = headers ? headers.getAll('Authorization'): null;
  if (!authorizationHeaders) {
      authorizationHeaders = [];
  }

  if (!this.itemExists(authorizationHeaders, (item: string) => item.indexOf('Bearer ') == 0)) {
      let token = this._tokenService.getToken();
      if (headers && token) {
          headers = headers.set('Authorization', 'Bearer ' + token);
      }
  }

  return headers;
}

protected handleSuccessResponse(event: HttpEvent<any>, interceptObservable: Subject<HttpEvent<any>>): void{
  var self = this;

  if (event instanceof HttpResponse) {
      if (event.body instanceof Blob && event.body.type && event.body.type.indexOf("application/json") >= 0){
          var clonedResponse = event.clone();
          
          self.configuration.blobToText(event.body).subscribe(json => {
              const responseBody = json == "null" ? {}: JSON.parse(json);
              
              var modifiedResponse = self.configuration.handleResponse(event.clone({
                  body: responseBody
              }));
              
              interceptObservable.next(modifiedResponse.clone({
				  body: new Blob([JSON.stringify(modifiedResponse.body)], { type: 'application/json' })

              }));

			  interceptObservable.complete();

			  this.spinnerService.isLoading.next(0);
        

          });
      } else {
          interceptObservable.next(event);
		  interceptObservable.complete();
		  
		  this.spinnerService.isLoading.next(0);


      }
  }

	
}

protected handleErrorResponse(error: any, interceptObservable: Subject<HttpEvent<any>>): Observable<any> {
  var errorObservable = new Subject<any>();
	
  if(!(error.error instanceof Blob)){
      interceptObservable.error(error);
      interceptObservable.complete();
      console.log('INTERCEPTORDEN GELEN1 : ERROR')
      console.log(error);
      this.spinnerService.isLoading.next(0);

      if(error.ok == false){
        this._uiMessage.modal.error(error.statusText, "Please check the connection!", null);
      }
      else{
        this._uiMessage.modal.error(error.statusText, error.message, null);
      }
	  
	  

      return null
      //return of({});
  }

	this.configuration.blobToText(error.error).subscribe(json => {
      const errorBody = (json == "" || json == "null") ? {}: JSON.parse(json);
      const errorResponse = new HttpResponse({
          headers: error.headers,
          body: errorBody
      });

      var ajaxResponse = this.configuration.getAbpAjaxResponseOrNull(errorResponse);
      
		if (ajaxResponse != null) {

			this.configuration.handleAbpResponse(errorResponse, ajaxResponse);

      } else {
          this.configuration.handleNonAbpErrorResponse(errorResponse);
      }

      errorObservable.complete();
      
      //prettify error object.
      error.error = errorBody;
      interceptObservable.error(error);
      interceptObservable.complete();
      
     // this._uiMessage.modal.error(error.statusText, error.message, null);

	  this.spinnerService.isLoading.next(0);

  });
  
  return errorObservable;
}

private itemExists<T>(items: T[], predicate: (item: T) => boolean): boolean {
  for (let i = 0; i < items.length; i++) {
      if (predicate(items[i])) {
          return true;
      }
  }

  return false;
}

}
